// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4bae9bb4","455":"7e84fd8b","977":"7081baa3"}[chunkId] + ".chunk.js";
};